import { useState, useCallback, useEffect } from 'react'
import { CrmCompany, listCompanies, mergeCompanies, deleteCompany } from 'api/oracleApi'

export function useCompanies(needsReviewOnly = false, enabled = true) {
    const [companies, setCompanies] = useState<CrmCompany[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const fetch = useCallback(async () => {
        setLoading(true)
        setError('')
        try {
            const data = await listCompanies(needsReviewOnly ? { status: 'needs_review' } : { limit: 200 })
            setCompanies(data)
        } catch (e) {
            setError('Failed to load companies')
        } finally {
            setLoading(false)
        }
    }, [needsReviewOnly])

    useEffect(() => {
        if (enabled) {
            fetch()
        }
    }, [fetch, enabled])

    const merge = useCallback(
        async (fromId: string, intoId: string) => {
            await mergeCompanies(fromId, intoId)
            await fetch()
        },
        [fetch]
    )

    const remove = useCallback(
        async (id: string) => {
            await deleteCompany(id)
            await fetch()
        },
        [fetch]
    )

    return { companies, loading, error, refetch: fetch, merge, remove }
}
